import { useEffect, useState } from 'react';
import { generatePath } from 'react-router-dom';
import { ReactComponent as Logo } from '../../../assets/img/PXUSLogo.svg';
import { ARCHIVE } from '../../../settings/urls';
import DashboardSidebar from '../../../container/Dashboard/sidebar';
import { MOBILE_BREAKPOINT } from '../../../settings/constants';
import { useAuth } from '../../../context/Auth';
import { useCompanyCtx } from '../../../context/integrations/Company';
import { ENV } from '../../../settings/constants';
import {
    StyledLayout,
    StyledHeader,
    StyledSider,
    StyledPageTitle,
    StyledLogoutButton,
    StyledLink,
    StyledContent,
    RightSection,
} from './style';
import NoLicense from './NoLicense';

const getSectionByActive = (active) => {
    switch (active) {
        case 'Admin Panel':
            return 'admin';
        case 'Archive':
        case 'Test':
        case 'Tensile':
        case 'Advanced Filters':
            return 'archive';
        case 'Insights':
            return 'insights';
        default:
            return null;
    }
};

const canViewPage = (active, userInfo) => {
    if (!userInfo.email || !active) return true;

    switch (getSectionByActive(active)) {
        case 'admin':
            return userInfo.isAdmin;
        case 'archive':
            return userInfo.archive;
        case 'insights':
            return userInfo.insights;
        default:
            return false;
    }
};

const getDemoImage = (active) => {
    switch (getSectionByActive(active)) {
        case 'archive':
            return { src: '/images/demos/archive.jpg', alt: 'Archive' };
        case 'insights':
            return { src: '/images/demos/insights.jpg', alt: 'Insights' };
        default:
            return null;
    }
};

const Layout = ({ children, sectionActive, active }) => {
    const auth = useAuth();
    const { userInfo } = useCompanyCtx();
    const [isMobile, setIsMobile] = useState(
        window.innerWidth < MOBILE_BREAKPOINT
    );
    const [isCollapsed, setIsCollapsed] = useState(true);

    function handleWindowSizeChange() {
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    useEffect(() => {
        setIsCollapsed(true);
    }, [isMobile]);

    /* TODO */

    return (
        <StyledLayout>
            <StyledHeader className={auth.user ? 'auth' : 'noauth'}>
                {auth.user && (
                    <StyledLink to={`/${generatePath(ARCHIVE)}`}>
                        <Logo alt="PLXUS" />
                    </StyledLink>
                )}
                <pre style={{ marginLeft: 3, backgroundColor: 'yellow' }}>
                    {ENV}
                </pre>
                {active && <StyledPageTitle>{active}</StyledPageTitle>}
                {auth.user && (
                    <RightSection>
                        {userInfo && !isMobile && (
                            <>
                                {userInfo.name}{' '}
                                {userInfo.name && userInfo.company && '-'}{' '}
                                {userInfo.company}
                            </>
                        )}
                        <StyledLogoutButton onClick={auth.logOut}>
                            Sign out
                        </StyledLogoutButton>
                    </RightSection>
                )}
            </StyledHeader>
            <StyledSider
                defaultCollapsed
                collapsible={isMobile}
                collapsed={isMobile ? isCollapsed : true}
                collapsedWidth={isMobile ? 0 : undefined}
                onCollapse={setIsCollapsed}
                width="120px"
            >
                {auth.user ? (
                    <DashboardSidebar
                        sectionActive={sectionActive}
                        active={active}
                        isMobile={isMobile}
                    />
                ) : null}
            </StyledSider>

            {canViewPage(active, userInfo) ? (
                <StyledContent>{children}</StyledContent>
            ) : (
                <NoLicense image={getDemoImage(active)} active={active} />
            )}
        </StyledLayout>
    );
};

export default Layout;
